import { useAtomValue } from "../editor-jotai";
import { recordingStatusAtom } from "../recording/atoms";

import "./RecordingBorderOverlay.scss";

export const RecordingBorderOverlay = () => {
  const status = useAtomValue(recordingStatusAtom);

  if (status !== "recording") {
    return null;
  }

  return <div className="recording-border-overlay" />;
};
